export function HowStep({ n, title, body }: { n: string; title: string; body: string }) {
  return (
    <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
      <div style={{
        width: 32, height: 32, borderRadius: 999,
        background: "var(--tp-accent2)", color: "#fff",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "var(--tp-font-body)", fontWeight: 700, fontSize: 15,
        flexShrink: 0, border: "2px solid var(--tp-ink)",
      }}>{n}</div>
      <div style={{ flex: 1, paddingTop: 2 }}>
        <div style={{ fontFamily: "var(--tp-font-body)", fontSize: 17, fontWeight: 700, lineHeight: 1.25, color: "var(--tp-ink)" }}>{title}</div>
        <div style={{ fontFamily: "var(--tp-font-body)", fontSize: 15, lineHeight: 1.45, color: "var(--tp-ink)", marginTop: 3 }}>{body}</div>
      </div>
    </div>
  );
}
